import { Assert } from "../../Assert";
import { PartialNullable } from "../../Extensions";
import { ObjectHelper } from "../../Helpers/ObjectHelper";
import { StringHelper } from "../../Helpers/StringHelper";
import { $$, JNative } from "../../JNative";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyBoolean } from "../../RadObject";
import { IInputControl, InputControl, InputControlPropertyValues } from "./InputControl";
import { NAMESPACE } from "./_Namespace";

import "./Switch.scss";

export type SwitchPropertyValues =
    InputControlPropertyValues
    & {
    };

export type SwitchProperties = {
    [name in keyof SwitchPropertyValues]: Property<SwitchPropertyValues[name]>
};

export interface ISwitch extends IInputControl, SwitchProperties
{
}

export class Switch extends InputControl implements ISwitch
{
    // #region Static

    public static override classNamespace = NAMESPACE + "Switch";
    public static override className = "Switch";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<SwitchPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                value: false,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected $$labelElement?: JNative<HTMLElement>;
    protected $$valueElement?: JNative<HTMLInputElement>;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<SwitchPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-switch ui toggle checkbox");
        this._elementValueSet(this.value.get());
    }

    // #endregion

    // #region Protected Methods

    protected _elementValueChanged()
    {
        if (!this.__processElementValueChanged)
            return;

        this.value.set(this._elementValueGet());
    }
    protected _elementValueGet()
    {
        return this.$$valueElement?.prop("checked");
    }
    protected _elementValueSet(value: any)
    {
        this.__processElementValueChanged = false;
        this.$$valueElement?.prop("checked", !!value);
        this.__processElementValueChanged = true;
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: SwitchPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.value = new PropertyBoolean(this, propertyValues.value, this._valueChanged);

        this.value.overrideSet((value, next) =>
        {
            value = ObjectHelper.asDotNetType(value, "System.Boolean, System.Private.CoreLib");

            this._elementValueSet(value);
            next(this._elementValueGet());
        });
    }

    protected override _bindEvents()
    {
        super._bindEvents();

        Assert.isNotNullOrUndefined(this.$$valueElement, "this.$$valueElement");

        this.$$valueElement.on("change", () => { this._elementValueChanged(); });
    }
    protected override _createElement()
    {
        const
            $$element = super._createElement();

        this.$$valueElement = $$<HTMLInputElement>(StringHelper.formatWithHtmlEncode("<input id=\"{0}-input\" type=\"checkbox\" />", this.controlId)).appendTo($$element);
        this.$$labelElement = $$(StringHelper.formatWithHtmlEncode("<label for=\"{0}-input\"></label>", this.controlId)).appendTo($$element);

        return $$element;
    }
    protected override _enabledChanged(change: PropertyChange<boolean>)
    {
        this.$$valueElement?.prop("disabled", change.currentValue ? StringHelper.empty : "disabled");
    }
    protected override _textChanged(change: PropertyChange<string>)
    {
        super._textChanged(change);
        this.$$labelElement?.text(change.currentValue);
    }

    // #endregion

    // #endregion
}

